export default __webpack_public_path__ + "static/media/image_canada.07849426.png";